/** @format */

import { Box, Button, Text, Spinner, HStack, Icon } from "@chakra-ui/react";
import { usePersonalizacao } from "../../../context/usePersonalizacao";
import { useRecomendacao } from "../../../context/useRecomendacao";
import { validaValidadede } from "../../../utils";
import { FaRegClock } from "react-icons/fa";
import moment from "moment";
import { useSession } from "../../../context/useSession";
import { useState } from "react";
import { ModalMsg } from "../../ModalMsg";

export function ButtonAtivaDesconto({ props, horizontal, descricao }) {
  const { ativaDesconto } = useRecomendacao();
  const {
    personalizacao: { card },
  } = usePersonalizacao();

  const {
    idoferta,
    validadede,
    validadeate,
    validoapartir = validaValidadede({
      validadede: validadede,
    }),
    ativado,
  } = props;
  const { session } = useSession();
  const [modalMsg, setModalMsg] = useState("");

  const handleAtivaDesconto = () => {
    if (!session?.cpfcnpj) {
      setModalMsg("Você precisa estar logado para ativar esta oferta.");
      return;
    }
    ativaDesconto({ idoferta: idoferta });
  };

  function formataExpiracaoDias(date) {
    const date1 = moment(new Date(date + "T23:59:59.999")).utc()
    const date2 = moment(new Date()).hour(0).minute(0).second(0).utc();

    let format = date1.diff(date2, "days");

    if (format === 0) {
      return "Expira Hoje";
    } else if (format === 1) {
      return "Expira Amanhã";
    } else {
      return "Expira em " + format + " dias";
    }
  }

  return (
    <>
      <ModalMsg message={modalMsg} setMessage={setModalMsg} />
      <Button
        type="button"
        cursor="pointer"
        w="100%"
        disabled={validoapartir || ativado === true || ativado === "loading"}
        background={
          validoapartir || ativado === true
            ? card?.descontoexclusivo?.bgbotaoofertaativada
              ? card?.descontoexclusivo?.bgbotaoofertaativada
              : card?.bgbotaoofertaativada
              ? card?.bgbotaoofertaativada
              : "#EDEEF2"
            : card?.descontoexclusivo?.bgbotaoativaroferta
            ? card?.descontoexclusivo?.bgbotaoativaroferta
            : card?.bgbotaoativaroferta
        }
        _disabled={{}}
        padding="0.75rem"
        display="flex"
        alignItems="center"
        justifyContent="center"
        borderTopRadius={descricao ? "md" : "none"}
        borderBottomRadius={"md"}
        transition="filter 0.2s"
        _hover={[{ filter: ativado !== true && "brightness(0.8)" }]}
        onClick={handleAtivaDesconto}
      >
        <Box>
          {ativado === "loading" ? (
            <Spinner size="sm" color="#FFF" />
          ) : (
            <HStack alignItems="center">
              {ativado && (
                <Icon
                  as={FaRegClock}
                  color={
                    card?.descontoexclusivo?.colortextbotaoofertaativada
                      ? card?.descontoexclusivo?.colortextbotaoofertaativada
                      : card?.colortextbotaoofertaativada
                      ? card?.colortextbotaoofertaativada
                      : "#555861"
                  }
                  size={16}
                />
              )}
              <Text
                color={
                  validoapartir || ativado
                    ? card?.descontoexclusivo?.colortextbotaoofertaativada
                      ? card?.descontoexclusivo?.colortextbotaoofertaativada
                      : card?.colortextbotaoofertaativada
                      ? card?.colortextbotaoofertaativada
                      : "#555861"
                    : card?.descontoexclusivo?.colortextbotaoativaroferta
                    ? card?.descontoexclusivo?.colortextbotaoativaroferta
                    : card?.colortextbotaoativaroferta
                }
                fontSize="1rem"
                fontWeight="bold"
                textAlign="center"
              >
                {!ativado ? "Ativar Oferta" : formataExpiracaoDias(validadeate)}
              </Text>
            </HStack>
          )}
        </Box>
      </Button>
    </>
  );
}
